import request from 'utils/request'

// 添加
export const add = data => request().post('card/addTarget', data)

// 删除
export const remove = id => request().get(`card/delete/${id}`)

// 编辑
export const update = data => request().post('card/updateTarget', data)

// 获取列表数据
export const getTableData = data => request().post('card/target/page', data)

//导出
export const exportLists = data =>
  request().post('card/upload/export', data, {
    responseType: 'arraybuffer',
  })

// 获取列表数据
export const getTableDatas = () => request().post('card/select/target')

// 获取列表数据
export const selectOption = id => request().get(`card/select/option/${id}`)
// 添加
export const addOptions = data => request().post('card/addOption', data)
// 获取指标是否被引用
export const getTarget = id => request().get(`card/getTarget/${id}`)